import { configureStore } from '@reduxjs/toolkit';
import isLoginReducer from  '../features/login/loginSlice.js';

export default configureStore({
  reducer: {
    islogin: isLoginReducer,
  },
});